import React, { useState } from 'react';
import useGoogleApi from "./useGoogleApi";
import { OpenAI } from "openai";
import StatusAlert from "../components/StatusAlert";
import {API_BASE_URL, EXTRACT_JOB_DOCUMENT_ENDPOINT, GET_JSON_DATA_ENDPOINT} from "../redux/services/apiConstant";
import { useSelector } from 'react-redux';

const extractApi = 'http://localhost:5000/api/extract';

const key = "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";

const openai = new OpenAI({
    apiKey: key,
    dangerouslyAllowBrowser: true, // ⚠️ exposes key to users
});
function useAIRateConfirmation() {
    const token = useSelector((state) => state?.authenticate?.token);

    let prompt = `You are an AI assistant extracting trucking job details.

    Extract the following fields from the rate confirmation text:

    - job_amount (number, no currency symbols)
    - pickup:
      - address (string)
      - contact_person (string or null)
      - contact_phone (string or null)
      - datetime (Y-m-d H:i:s or null)
    - drop:
      - address (string)
      - contact_person (string or null)
      - contact_phone (string or null)
      - datetime (Y-m-d H:i:s or null)
    
    Rules:
    - Return RAW JSON only
    - Do NOT use markdown
    - Do NOT use backticks
    - Do NOT add explanations or text
    - Use null if data is missing
    - Job amount must be numeric (example: 1400.00)
    
    Required JSON format:
    
    {
      "job_amount": 0,
      "pickup": {
        "address": "",
        "contact_person": null,
        "contact_phone": null,
        "datetime": null
      },
      "drop": {
        "address": "",
        "contact_person": null,
        "contact_phone": null,
        "datetime": null
      }
    }
    
    Rate confirmation text:
    `;
    let AI_text = '';
    let [aiJsonResponse, setAIJsonResponse] = useState({});
    const [promiseLogs, setPromiseLogs] = useState({
        step: 0,
        loading: false,
        status: 'pending',
        message: ''
    });

    const { getPlaceInformation } = useGoogleApi();

    const scanning = (file) => new Promise(async (resolve, reject) => {
        try {
            setPromiseLogs({
                step: 1,
                loading: true,
                status: 'pending',
                message: 'Scanning Your Rate Confirmation Document'
            })

            setTimeout(() => setPromiseLogs({
                step: 1,
                loading: true,
                status: 'scaning',
                message: 'Scanning Your Rate Confirmation Document'
            }), 2000)

            const formData = new FormData();
            formData.append("file", file);

            const response = await fetch(API_BASE_URL + EXTRACT_JOB_DOCUMENT_ENDPOINT, {
                method: "POST",
                body: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            console.log("data", data);

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }
            AI_text = data.text;
            setPromiseLogs({
                step: 1,
                loading: false,
                status: 'success',
                message: 'Successfully Document Scanned'
            });
            resolve(true)

        } catch (err) {
            setPromiseLogs({
                step: 1,
                loading: false,
                status: 'failed',
                message: 'Scanning Your Rate Confirmation Document'
            });
            console.log("catch :", err.message);
            reject(false)
        }
    });
    const extracting = () => new Promise(async (resolve, reject) => {
        try {

            setPromiseLogs({
                step: 2,
                loading: true,
                status: 'extract',
                message: 'Finding information from extraction data'
            });

            const body = new FormData()
            body.append('extract_data', prompt + AI_text)

            const response = await fetch(API_BASE_URL + GET_JSON_DATA_ENDPOINT, {
                method: "POST",
                body: body,
                headers: {
                    Accept : 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }


            if (typeof data.text === "string" && JSON.parse(data.text)) {
                setAIJsonResponse({...data.data});
                // console.log("JSON", {...JSON.parse(data.text)});
            }
            setPromiseLogs({
                step: 2,
                loading: false,
                status: 'success',
                message: 'Successfully Information Extracted'
            });
            resolve({...data.data})
        }
        catch(err){
            setPromiseLogs({
                step: 2,
                loading: false,
                status: 'failed',
                message: 'Error:' + err.message
            });
            reject({})
        }
    });
    const documentHandler = async (file) => {

        return scanning(file)
            .then(async (res) => {
                console.log("extracting");
                return await extracting();
            })
            .then(async (res) => {
                console.log("getPlaceInformation", res);
                setPromiseLogs({
                    step: 3,
                    loading: true,
                    status: 'pending',
                    message: 'Placing data in input fields'
                });
                const pickUp = await getPlaceInformation(res?.pickup?.address);
                const dropOff = await getPlaceInformation(res?.drop?.address);
                const completeData = {
                    ...res,
                    pickup: {
                        ...res?.pickup,
                        ...pickUp
                    },
                    drop: {
                        ...res?.drop,
                        ...dropOff
                    },
                };
                setAIJsonResponse(completeData)

                setPromiseLogs({
                    step: 3,
                    loading: false,
                    status: 'success',
                    message: 'successfully done all things.'
                });
                return completeData;
            })
            .catch(() => {
                return aiJsonResponse;
            });
    }

    const ProgressBar = ({ file }) => (
        <>
            {
                promiseLogs.step !== 0 &&
                <StatusAlert
                    loading={promiseLogs?.loading}
                    status={promiseLogs?.status}
                    message={promiseLogs?.message}
                    retry={() => documentHandler(file)}
                    type="in"
                />
            }
        </>
    )
    const ProgressBar2 = ({ file }) => (
        <>
            {
                promiseLogs.step !== 0 &&
                <StatusAlert
                    loading={promiseLogs?.loading}
                    status={promiseLogs?.status}
                    message={promiseLogs?.message}
                    retry={() => documentHandler(file)}
                    type="out"
                />
            }
        </>
    )
    // console.log("AI",aiJsonResponse);

    return {
        documentHandler,
        ProgressBar,
        aiJsonResponse
    };
}

export default useAIRateConfirmation;
